module.exports = __webpack_public_path__ + "media/icons/clipboard-0f715e9c.svg";